import { useMutation } from "@apollo/client";

import { MapEditorPlannerAreaPanel_PlannerVisitDeleteDocument } from "../../mutations.generated";
import { MapEditorPlannerAreaPanelDocument } from "../../queries.generated";

export function useDeletePlannerVisitMutation() {
    const [mutate, result] = useMutation(MapEditorPlannerAreaPanel_PlannerVisitDeleteDocument, {
        refetchQueries: [MapEditorPlannerAreaPanelDocument],
    });

    const deletePlannerVisit = (plannerVisitId: string, deletionReason: string) =>
        mutate({
            variables: {
                input: {
                    plannerVisitId,
                    deletionReason,
                },
            },
        });

    return [deletePlannerVisit, result] as const;
}
